export const textLang: any = {
    jp: {
        title: 'タスクを完了してポイントを獲得',
        desc1: '製品ページを',
        desc2: '秒間閲覧すると、再チェックインの機会を獲得できます。',
        btn: 'GO',
    },
    us: {
        title: 'Complete Tasks to Earn EcoCredits',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconds',
        btn: 'GO',
    },
    ca: {
        title: 'Complete Tasks to Earn EcoCredits',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconds',
        btn: 'GO',
    },
    au: {
        title: 'Complete Tasks to Earn EcoCredits',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconds',
        btn: 'GO',
    },
    eu: {
        title: 'Complete Tasks to Earn EcoCredits',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconds',
        btn: 'GO',
    },
    uk: {
        title: 'Complete Tasks to Earn EcoCredits',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconds',
        btn: 'GO',
    },
    de: {
        title: 'Schließen Sie Aufgaben ab, um EcoCredits zu sammeln',
        desc1: 'Sie haben die Möglichkeit, sich für einen Wiederherstellungs-Check-in nach ',
        desc2: ' Sekunden Surfen auf der Produktseite erneut einzuchecken.',
        btn: 'Los',
    },
    es: {
        title: 'Completar tareas para ganar EcoCredits',
        desc1: 'Tendrás la oportunidad de recuperar visitas si navegas por la página del producto durante ',
        desc2: ' segundos',
        btn: 'Ir',
    },
    fr: {
        title: 'Accomplissez des tâches pour gagner des EcoCredits',
        desc1: 'Vous pouvez récupérer une confirmation de présence manquée en visitant la page du produit pendant ',
        desc2: ' secondes',
        btn: 'Visiter la page',
    },
    it: {
        title: 'Completa le attività per guadagnare EcoCredits',
        desc1: 'Se navighi nella pagina del prodotto per ',
        desc2: ' secondi, avrai l’opportunità di recuperare un check-in mancato',
        btn: 'Vai',
    },
    kr: {
        title: 'EcoCredits 획득 작업 완료',
        desc1: '',
        desc2: '초 동안 제품 페이지를 탐색하면 체크인 보충 기회를 얻을 수 있습니다',
        btn: '이동',
    },
    za: {
        title: 'Complete Tasks to Earn EcoCredits',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconds',
        btn: 'GO',
    },
    br: {
        title: 'Complete as tarefas para ganhar EcoCredits',
        desc1: 'Você terá a chance de fazer um check-in de compensação ao navegar pela página do produto por ',
        desc2: ' segundos.',
        btn: 'IR',
    },
    mx: {
        title: 'Completa tareas para ganar EcoCréditos',
        desc1: 'Para tener la posibilidad de un registro de recuperación, navega por la página de productos por ',
        desc2: ' segundos',
        btn: 'IR',
    },
    ph: {
        title: 'Complete Tasks to Earn EcoCredits',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconds',
        btn: 'GO',
    },
    nl: {
        title: 'Voltooi de taken om EcoCredits te verdienen',
        desc1: 'You will get a chance for a make-up check-in by browsing the product page for ',
        desc2: ' seconden lang op de productpagina te browsen',
        btn: 'GA',
    },
};
